import React from 'react';
// import Button from '@material-ui/core/Button';
// import Card from '@material-ui/core/Card';
// import CardActions from '@material-ui/core/CardActions';
// import CardContent from '@material-ui/core/CardContent';
// import CardMedia from '@material-ui/core/CardMedia';
import CssBaseline from '@material-ui/core/CssBaseline';
// import Grid from '@material-ui/core/Grid';
// import Typography from '@material-ui/core/Typography';
// import { makeStyles } from '@material-ui/core/styles';
// import Container from '@material-ui/core/Container';
// import Link from '@material-ui/core/Link';
// import { useHistory } from 'react-router-dom';
import "../CSS/HomePage.css"
// import { loginUrl } from '../spotify';
// import SpotifyWebApi from 'spotify-web-api-js';
// import Player from './Player'

// function Copyright() {
//   return (
//     <Typography variant="body2" color="textSecondary" align="center">
//       {'Copyright © '}
//       <Link color="inherit" href="https://material-ui.com/">
//         Bopify
//       </Link>{' '}
//       {new Date().getFullYear()}
//       {'.'}
//     </Typography>
//   );
// }

// const useStyles = makeStyles((theme) => ({
//   icon: {
//     marginRight: theme.spacing(2),
//   },
//   heroContent: {
//     backgroundColor: theme.palette.background.paper,
//     padding: theme.spacing(8, 0, 6),
//   },
//   heroButtons: {
//     marginTop: theme.spacing(4),
//   },
//   cardGrid: {
//     paddingTop: theme.spacing(8),
//     paddingBottom: theme.spacing(8),
//   },
//   card: {
//     height: '100%',
//     display: 'flex',
//     flexDirection: 'column',
//   },
//   cardMedia: {
//     paddingTop: '56.25%', // 16:9
//   },
//   cardContent: {
//     flexGrow: 1,
//   }
// }));

// const cards = [1, 2, 3, 4, 5, 6, 7, 8, 9];

export default function HomePage(props) {
    // const classes = useStyles();
    // const history = useHistory()

    // const goToNewPlaylist = () =>{
    //     history.push('/newPlaylist')
    // }
    
    // const goToPlaylist = (id) =>{
    //     history.push(`/playlist/${id}`)
    // }

    return (
        <React.Fragment>
        <CssBaseline />
        <main>
            
        </main>

        {/* <footer className={classes.footer}>

            <Copyright />
        </footer> */}
        </React.Fragment>
        // <>
        // </>
    );
}